module.exports = __webpack_public_path__ + "static/media/19ESCAP14.16f6da5b.jpg";